<template>
  <img
    class="object-cover"
    src="@/assets/images/navbar-icons/nav-rewards-icon.webp"
  >
</template>